module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f1Wdz"))).then(() => parcelRequire('3a9aZ'));